import React, { useEffect, createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
// Meta Pixel initialization
const initMetaPixel = () => {
  // Check if fbq already exists
  if (window.fbq) return;
  const f = window;
  const b = document;
  const e = 'script';
  const n: any = f.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
  };
  if (!f._fbq) f._fbq = n;
  n.push = n;
  n.loaded = true;
  n.version = '2.0';
  n.queue = [];
  const t = b.createElement(e);
  t.async = true;
  t.src = 'https://connect.facebook.net/en_US/fbevents.js';
  const s = b.getElementsByTagName(e)[0];
  s.parentNode.insertBefore(t, s);
  // Initialize Meta Pixel
  window.fbq('init', '892007766859689');
  window.fbq('track', 'PageView');
  // Add noscript fallback
  const noscript = document.createElement('noscript');
  const img = document.createElement('img');
  img.height = 1;
  img.width = 1;
  img.style.display = 'none';
  img.src = 'https://www.facebook.com/tr?id=892007766859689&ev=PageView&noscript=1';
  noscript.appendChild(img);
  document.body.appendChild(noscript);
};
// Initialize Meta Pixel when script loads
initMetaPixel();
render(<App data-id="element-683" />, document.getElementById('root'));